var _defs, _text, _path, _path2, _circle, _circle2, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogLabGreenLogoDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 962.26 304.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:175px;fill:#e6e6e6;font-family:Aldrich-Regular, Aldrich;}.cls-2{fill:none;stroke:#e6e6e6;stroke-linecap:round;stroke-miterlimit:10;stroke-width:17px;}.cls-3{fill:#29abe2;}.cls-4{fill:#00d865;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BlogLab-green-logo-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(264.14 216.36)"
  }, "BlogLab")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264,181c-14,0-23.86,8-23.86,23.56h0V321.44A34.7,34.7,0,0,1,205.29,356H108.71a34.7,34.7,0,0,1-34.85-34.56V204.56h0C73.86,190,65,181,51,181",
    transform: "translate(-42.5 -60)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188,249v.26a5,5,0,0,0,5,5h28V273H193a5,5,0,0,0-5,5v.26a5,5,0,0,0,5,5h28V303H193a5,5,0,0,0-5,5v.26a5,5,0,0,0,5,5h28V314c0,16.11-6.71,23.74-21.76,23.74H114.5c-15,0-21.77-7.63-21.77-23.74V208.69h36.83c8.19,0,18.17-2.56,24.78-7.32l6.58-4.73a20.42,20.42,0,0,1,23.64-.08l7.94,5.63a35.53,35.53,0,0,0,20.5,6.5h8V244H193A5,5,0,0,0,188,249Z",
    transform: "translate(-42.5 -60)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 103.5,
    cy: 9,
    r: 9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.5,
    cy: 50,
    r: 25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96.5,
    cy: 97,
    r: 18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188,249v.26a5,5,0,0,0,5,5h28V273H193a5,5,0,0,0-5,5v.26a5,5,0,0,0,5,5h28V303H193a5,5,0,0,0-5,5v.26a5,5,0,0,0,5,5h28V314c0,16.11-6.71,23.74-21.76,23.74H114.5c-15,0-21.77-7.63-21.77-23.74V208.69h36.83c8.19,0,18.17-2.56,24.78-7.32l6.58-4.73a20.42,20.42,0,0,1,23.64-.08l7.94,5.63a35.53,35.53,0,0,0,20.5,6.5h8V244H193A5,5,0,0,0,188,249Z",
    transform: "translate(-42.5 -60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogLabGreenLogoDark);
export default __webpack_public_path__ + "static/media/BlogLab-green-logo-dark.c3dd278dedabaa78e0c9cc8784d9f2dd.svg";
export { ForwardRef as ReactComponent };